import { useState } from 'react';
import { useApp } from '../context';
import { allNavEntries, orderedNav } from '../nav';
import { savePrefs, usePrefs } from '../prefs';
import { usePolicy } from './TopNav';
import { useTautulliStatus } from '../tautulli';

/** Menu aanpassen: volgorde en wat zichtbaar is (per profiel, op elk apparaat). */
export function NavSettings() {
  const { me, libraries } = useApp();
  const prefs = usePrefs();
  const policy = usePolicy(me.profile?.uuid ?? '');
  const tautulli = useTautulliStatus(me.profile?.uuid ?? '');
  const [status, setStatus] = useState<string | null>(null);
  const entries = orderedNav(allNavEntries(libraries, policy ? { ...policy, server: tautulli?.inNav === true, plex: me.plex !== false } : null), prefs.nav).filter((e) => e.allowed);
  const hidden = new Set(prefs.nav?.hidden ?? []);

  const save = (order: string[], hid: Set<string>) => {
    setStatus('Opslaan…');
    savePrefs({ nav: { order, hidden: [...hid] } }).then(() => setStatus('Opgeslagen')).catch(() => setStatus('Opslaan mislukt'));
  };
  const move = (i: number, d: -1 | 1) => {
    const ids = entries.map((e) => e.id);
    const j = i + d;
    if (j < 0 || j >= ids.length) return;
    [ids[i], ids[j]] = [ids[j], ids[i]];
    save(ids, hidden);
  };
  const toggle = (id: string) => {
    const h = new Set(hidden);
    if (h.has(id)) h.delete(id);
    else h.add(id);
    save(entries.map((e) => e.id), h);
  };
  const reset = () => {
    setStatus('Opslaan…');
    savePrefs({ nav: null }).then(() => setStatus('Standaardmenu terug')).catch(() => setStatus('Opslaan mislukt'));
  };

  return (
    <section className="settings-block" aria-label="Menu">
      <h2>Menu {status && <span className="subtle pb-status" role="status">{status}</span>}</h2>
      <p className="subtle hint">Kies wat er in het menu bovenin staat en in welke volgorde. Geldt voor dit profiel, op elk apparaat. Zoeken, instellingen en je profiel blijven altijd rechtsboven.</p>
      <ol className="nav-edit" data-focus-group>
        {entries.map((e, i) => (
          <li key={e.id} className={hidden.has(e.id) ? 'is-hidden' : ''}>
            <span className="nav-edit-name">{e.label}{e.id.startsWith('lib:') && <span className="subtle"> · bibliotheek</span>}</span>
            <button className="btn btn-sm" onClick={() => toggle(e.id)} aria-pressed={!hidden.has(e.id)} aria-label={`${e.label} ${hidden.has(e.id) ? 'tonen' : 'verbergen'}`}>
              {hidden.has(e.id) ? 'Verborgen' : 'Zichtbaar'}
            </button>
            <button className="btn btn-sm" onClick={() => move(i, -1)} disabled={i === 0} aria-label={`${e.label} omhoog`}>↑</button>
            <button className="btn btn-sm" onClick={() => move(i, 1)} disabled={i === entries.length - 1} aria-label={`${e.label} omlaag`}>↓</button>
          </li>
        ))}
      </ol>
      <button className="btn btn-sm" onClick={reset}>Standaardmenu</button>
    </section>
  );
}
